import {Utils} from './Utils'

export interface PopupConfig {
    window: string;
    overlay?: string;
}

export class Popup {
    protected isActive: boolean;
    protected readonly elements: {
        window: HTMLElement;
        overlay?: HTMLElement;
        triggers?: NodeListOf<HTMLElement>[];
    };

    constructor({window, overlay}: PopupConfig) {
        this.isActive = false;
        this.elements = {
            window: document.querySelector(window),
            overlay: document.querySelector(overlay),
            triggers: []
        };
        this.bind();
    }

    protected bind(): void {
        document.addEventListener( 'keydown', (evt) => this.onEscapeKeyPressing(evt), false );
    }

    protected onEscapeKeyPressing(evt: KeyboardEvent): void {
        if (this.isActive && evt.key === `Escape`) this.toggle();
    }

    public addTriggers(selectors: string): void {
        const triggers: NodeListOf<HTMLElement> = document.querySelectorAll(selectors);
        if (!this.elements.window || !triggers.length) return;
        this.elements.triggers.push(triggers);
        triggers.forEach(trigger => {
            trigger.addEventListener(`click`, (evt) => this.onTriggerClick(evt), false);
        });
    }

    protected onTriggerClick(evt: Event): void {
        evt.preventDefault();
        this.toggle();
    }

    public toggle(): void {
        const {window, overlay, triggers} = this.elements;

        this.isActive = !this.isActive;
        Utils.toggleScroll();

        Utils.toggleClass(window, `is-active`);
        Utils.toggleClass(overlay, `is-active`);
        triggers.forEach(nodes => {
            nodes.forEach(node => Utils.toggleClass(node, `is-triggered`));
        });
    }

    get state(): string {
        return this.isActive ? `opened` : `closed`;
    }
}